import { SmilePlus } from 'lucide-react';

interface ReactionItem {
  emoji: string;
  count: number;
  users: string[];
  reacted: boolean;
}

interface Props {
  reactions: ReactionItem[];
  onToggle: (emoji: string) => void;
  onAddReaction: () => void;
}

export default function ReactionBadges({ reactions, onToggle, onAddReaction }: Props) {
  if (reactions.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1 mt-1">
      {reactions.map((r) => (
        <button key={r.emoji} onClick={() => onToggle(r.emoji)}
          title={r.users.join(', ')}
          className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-sm border transition-colors
            ${r.reacted
              ? 'bg-blue-50 border-blue-300 text-blue-700'
              : 'bg-gray-50 border-transparent hover:border-gray-300 text-gray-600'
            }`}>
          <span className="text-sm">{r.emoji}</span>
          <span>{r.count}</span>
        </button>
      ))}
      {/* CHG-131: 액션 바와 동일한 SmilePlus 아이콘으로 통일 (메시지 액션 floating bar와 시각적 일관성) */}
      <button
        onClick={onAddReaction}
        title="리액션 추가"
        className="inline-flex items-center px-1.5 py-0.5 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
      >
        <SmilePlus className="size-3.5" />
      </button>
    </div>
  );
}
